import { DecimalPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { NumberInputComponent, TranslatePipe } from '@softline/ui-core';
import { BeweauBean } from '../../../types/beweau-bean';

@Component({
  selector: 'soft-tp-list-item-input',
  imports: [DecimalPipe, NumberInputComponent, TranslatePipe],
  templateUrl: './list-item-input.component.html',
  styleUrls: ['./list-item-input.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListItemInputComponent {
  readonly editable = input(true);
  readonly showError = input(false);
  readonly index = input(0);
  readonly item = input<BeweauBean>();
  readonly originalItem = input<BeweauBean>();

  readonly quantityChange = output<number>();
  readonly delete = output<void>();

  scrollToTop(id: string): void {
    const element = document?.getElementById(id);
    element?.scrollIntoView({ behavior: 'smooth' });
  }
}
